// assumption: package `highlight.js` is installed
import highlight from 'highlight.js';
import 'highlight.js/styles/monokai-sublime.css';

window.hljs = highlight;